import React from 'react'
import styled, { css } from 'styled-components'
import { ThemeSkeleton } from './ThemeSkeleton'
import { Block, RadioButton, Text } from '@mote/ui'

export const AccountProfileTheme = ({
  onThemeSelection,
  isSelected,
  theme,
  userName,
  avatarUrl
}) => {
  return (
    <Root selected={isSelected} onClick={() => onThemeSelection(theme.value)}>
      <ThemeSkeleton theme={theme} userName={userName} avatarUrl={avatarUrl} />
      <ThemeSelectionContainer layout='horizontal' align='center' gap={8}>
        <RadioButton checked={isSelected} />
        <Text lineHeight={24} fontSize={15} fontWeight={500}>
          {theme.name}
        </Text>
      </ThemeSelectionContainer>
    </Root>
  )
}

const Root = styled.div`
  border: 1px solid transparent;
  transition: filter 150ms ease-in-out;
  cursor: pointer;

  &:hover {
    filter: drop-shadow(0px 1px 3px rgba(113, 101, 129, 0.04))
      drop-shadow(0px 3px 14px rgba(113, 101, 129, 0.08))
      drop-shadow(0px 8px 32px rgba(113, 101, 129, 0.1));
  }

  ${({ selected }) =>
    selected &&
    css`
      border-color: #ac0ae8;
    `};
`
const ThemeSelectionContainer = styled(Block)`
  background: #f6f6f9;
  padding: 16px;
`
